// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_3o-0";
export var eligibilityCardNotEligible = "_3o-1";